<template>
    <div>
        <div class="tabs">
            <ul class="nav nav-tabs">
                <li v-for="(module,index) in modules" class="nav-item" >
                    <a class="nav-link" :class="{['bg-' + module.color]: true, active: index==0}" data-toggle="tab" :href="`#modContent_${module.id}`">
                        <span :class="moduleIconClasses(module)"></span>
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div v-for="(module,index) in modules" class="collapse tab-pane" :id="`modContent_${module.id}`" :key="module.id" :class="{active: index == 0}" role="tabpanel">
                    <content-container :module="module">
                        <slot :module="module" name="primary"></slot>
                    </content-container>

                    <slot :module="module" name="secondary"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentContainer from './ContentContainer'

	export default{
        components: {
            ContentContainer,
        },
        props: {
            modules: {
                required: true,
                type: Array
            },
        },
		data(){
			return {
			}
        },
		methods: {
            bgColorClass: function(module) {
                return 'bg-' + module.color;
            },
            moduleIconClasses: function(module) {
                return [
                    'module-icons',
                    module.icon,
                    this.bgColorClass(module)
                ];
            }
		}
	}
</script>
